import { useMemo } from "react";
import { useQuery } from "@apollo/client";
import { GET_ALL_SUPER_USERS } from "./features/AddTickets/api/addTicketsQuery";

export const useSuperUsers = () => {
  const { data, loading, error } = useQuery(GET_ALL_SUPER_USERS);
  
  const superUserSet = useMemo(() => {
    if (!data?.super_user){
       return new Set<string>();}
    return new Set(data.super_user.map((u: { u_id: string }) => u.u_id));
  }, [data]);

  return {
    superUserSet,
    loading,
    error,
  };
};
